import md5 from 'js-md5'
import bykApi from '../bykApi';

//提交请求的参数封装
const fReqParam = (jo) => {
	let postTime = bykApi.timeHelper.fGetNowTime(2)
	//1.请求参数转成base64
	let postJsonStr = JSON.stringify(jo);
	let base64Str = Base64.encode(postJsonStr);

	//2.组装md5签名
	let orgSk = 'e28da0ac4598f2c6086b4808abfad117';
	let userSign = orgSk + base64Str + postTime + orgSk;
	userSign = md5(userSign);
	userSign = userSign.toLowerCase();

	//3.组装公用请求参数
	let postJson = {};
	postJson['ORG_AK'] = '70fa12264f4f5ef03189f4ba9f7fca6e';
	postJson['PHONE_NO'] = jo.PHONE_NO || '';
	if (jo.METHOD_NAME == 'SET_FB_WX_PAY_PATH') {
		postJson['T_FROM'] = 'bykSell';
	} else if (jo.METHOD_NAME == 'ZGYL_UP_SH_INFO') {
		postJson['T_FROM'] = 'payUpShInfo';
	} else {
		postJson['T_FROM'] = '电脑端';
	}
	postJson['POST_TIME'] = postTime;
	postJson['METHOD_NAME'] = jo.METHOD_NAME || '';
	postJson['JSON_STR'] = base64Str;
	postJson['USER_SIGN'] = userSign;
	postJson['USER_ID'] = jo.USER_ID || '';
	postJson['RANDOM_STR'] = jo.RANDOM_STR || '';
	postJson['USER_TOKEN'] = jo.USER_TOKEN || '';
	return postJson;
};


export default {
	fReqParam, //提交请求的参数封装
};



// WEBPACK FOOTER //
// ./src/common/requset/reqParm.js